export const FilterFieldKind = {
  TEXT: 'text',
  AUTOCOMPLETE: 'autocomplete',
  DATE: 'date',
};

export const FilterFieldKey = {
  SEARCH: 'search',
  PROCESS: 'processId',
  STARTED_AFTER: 'startedAfter',
  STARTED_BEFORE: 'startedBefore',
};

export const FILTER_FIELDS = [
  { key: FilterFieldKey.SEARCH, kind: FilterFieldKind.TEXT, label: 'Search' },
  { key: FilterFieldKey.PROCESS, kind: FilterFieldKind.AUTOCOMPLETE, label: 'Process' },
  { key: FilterFieldKey.STARTED_AFTER, kind: FilterFieldKind.DATE, label: 'Started after' },
  { key: FilterFieldKey.STARTED_BEFORE, kind: FilterFieldKind.DATE, label: 'Started before' },
];
